import React from 'react';
import styled, { css } from 'styled-components'
import { RoundedButton } from './RoundedButton';
import { FaCheck } from 'react-icons/fa';

import moment from 'moment';

const CheckInWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const TextContent = styled.div`
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
`

const RoundedButtonWithMargin = styled(RoundedButton)`
  margin-bottom: 15px;
  width: 100%;

  ${({ isCheckedIn }) =>  {
    if (!isCheckedIn) {
      return css`
        background: #f9d606;
        color: black;
      `
    } else {
      return css`
        background: black;
        color: #f9d606;
      `}
    }
  }
`

export const CheckIn = ({ pin, checkIn }) => {
  const lastCheckInFormatted = pin.dtLastCheckin && moment(pin.dtLastCheckin).startOf('second').fromNow();

  return (
    <CheckInWrapper>
      <RoundedButtonWithMargin handleClick={checkIn}
        isCheckedIn={pin.isCheckedIn}
        Icon={FaCheck}
      >
        { pin.isCheckedIn ? 'Посещено' : 'Отметить посещение' }
      </RoundedButtonWithMargin>
      <TextContent>Точку посетили {pin.checkinCount} раз</TextContent>
      { pin.dtLastCheckin && <TextContent>Последнее посещение {lastCheckInFormatted}</TextContent> }
    </CheckInWrapper>
  )
}
